import { Logger } from "../utils/logger";
import { dataAttributePrefix } from "../index";
import { DataTrackingClient } from "../core";
import Player from '@vimeo/player';
import EventEmitter from "events";
// declare var Vimeo: any;
export class VimeoMonitor {
    constructor() {
        this._trackingItems = [];
        this.trackedVideos = [];
        this._dataAttributePrefix = dataAttributePrefix;
        this._emitter = new EventEmitter();
        if (VimeoMonitor._instance) {
            throw new Error("Singleton class [VideoMonitor] can't be instantiated more than once. Call getInstance() instead");
        }
    }
    onPlayVideo(callBack) {
        Logger.verbose("Vimeo On Play - event attached.");
        this._emitter.on("play-vimeo", (ev, element, elementEventData) => {
            Logger.verbose("Vimeo On Play - 'play-vimeo' event called ");
            callBack.call(this, ev, element, elementEventData);
        });
    }
    addItem(objTrackingItem, element) {
        this._trackingItems.push(objTrackingItem);
        this._attachVimeoEvents(objTrackingItem, element);
    }
    addTrackedVideo(videoId) {
        this.trackedVideos.push(videoId);
    }
    getTrackingElementById(id) {
        let video = null;
        for (let i = 0; i < this.trackedVideos.length; i++) {
            if (this.trackedVideos[i] == id) {
                video = this.trackedVideos[i];
                break;
            }
        }
        ;
        return video;
    }
    getTrackedVideoById(id) {
        let trackingItem = null;
        for (let i = 0; i < this.trackedVideos.length; i++) {
            if (this.trackedVideos[i].elementId == id) {
                trackingItem = this.trackedVideos[i];
                break;
            }
        }
        ;
        return trackingItem;
    }
    static getInstance() {
        if (!VimeoMonitor._instance) {
            VimeoMonitor._instance = new VimeoMonitor();
        }
        return VimeoMonitor._instance;
    }
    /*
    public x_processVimeoTracking(trackingItem: TrackingItem, htmlElement: HTMLElement) {

        let _self = this;

        
        if (typeof Vimeo == 'undefined') {
            let vimeo_js = document.createElement('script');
            

            vimeo_js.onload = function () {
                _self._attachVimeoEvents(trackingItem, htmlElement);
            };

            vimeo_js.setAttribute('src', 'https://player.vimeo.com/api/player.js');
            document.head.appendChild(vimeo_js);

        } else {

            if (typeof Vimeo.Player !== 'function') {
                throw "it seems included Vimeo class is not of type actual vimeo player class";
            }

            
            this._attachVimeoEvents(trackingItem, htmlElement);
        }


        this._attachVimeoEvents(trackingItem, htmlElement);
        
    } */
    _attachVimeoEvents(trackingItem, element) {
        //let player = new Vimeo.Player(element);
        let player = new Player(element);
        let vimeoUrl = '';
        let iFrameSrc = element.getAttribute('src');
        if (iFrameSrc) {
            let urlParts = iFrameSrc.split('?');
            vimeoUrl = urlParts[0];
        }
        player.on('play', (ev) => {
            Logger.verbose("Vimeo Video ev:");
            Logger.verbose(ev);
            //let is_already_tracked = this.getTrackedVideoById(parseInt(ev.videoId));
            //https://player.vimeo.com/video/123456783?h=6e6dd591b7&title=0&byline=0&portrait=0
            let is_already_played_and_tracked = ev.seconds;
            if (is_already_played_and_tracked == 0) { // ev.seconds == 0
                //this.addTrackedVideo(ev.videoId);
                let elementId = element.getAttribute(this._dataAttributePrefix + "element-id");
                if (!elementId) {
                    Logger.error(this._dataAttributePrefix + "element-id data attribute not found on element");
                    return;
                }
                // Get the item from trackElements array based on the elementId
                //let item: Nullable<TrackingItem> = DataTrackingClient.getInstance().getTrackingElementById(parseInt(elementId));
                if (trackingItem == null) {
                    Logger.error("Element with id (" + elementId.toString() + ") not found in elements array");
                    Logger.verbose(this._trackingItems);
                    return;
                }
                if (trackingItem.elementSelector == "") {
                    Logger.error("elementSelector cannot be empty");
                    return;
                }
                player.getVideoTitle().then((title) => {
                    Logger.verbose("Vimeo Title - ", title);
                    let vimeoData = {};
                    vimeoData["video-title"] = title;
                    if (vimeoUrl) {
                        vimeoData["video-url"] = vimeoUrl;
                        let parts = vimeoUrl.split('/');
                        if (parts.length > 0) {
                            vimeoData["video-id"] = parts[parts.length - 1];
                        }
                    }
                    let elementEventData = DataTrackingClient.getInstance().prepareElementEventData(trackingItem, element);
                    elementEventData.vimeoData = vimeoData;
                    elementEventData.youtubeData = null;
                    this._emitter.emit("play-vimeo", ev, element, elementEventData);
                });
            }
            else {
                Logger.verbose("This Vimeo Video Play Tracking Is Already Done.");
            }
        });
    }
}
VimeoMonitor._instance = null;
